import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import { documentStatus, mimeTypes } from "../config";

export default function DocumentationFile({
  file,
  number,
  document,
  isUploaded,
  isUploading,
  removeFile,
}) {
  const { palette, customBorderRadius, spacing } = useTheme();

  if (file === undefined || document === undefined) {
    return null;
  }

  const fileType = file?.mime_type?.match(mimeTypes.IMAGE)
    ? "image"
    : file?.mime_type?.match(mimeTypes.PDF)
    ? "pdf"
    : "other";

  const fileName = !isUploaded
    ? file?.name
    : isUploaded && fileType === "image"
    ? `imagen${number && `-${number}`}.${
        file?.mime_type?.split("/")[file?.mime_type?.split("/").length - 1]
      }`
    : isUploaded && fileType === "pdf"
    ? `documento${number && `-${number}`}.${
        file?.mime_type?.split("/")[file?.mime_type?.split("/").length - 1]
      }`
    : file?.name;

  return (
    <Paper
      key={file.name}
      elevation={0}
      style={{
        marginTop: spacing(2),
        borderRadius: customBorderRadius.paper,
        boxShadow: "0px 0px 15px 2px rgba(0, 0, 0, 0.06)",
      }}
    >
      <Box p={2}>
        <Grid container alignItems="center">
          <Grid item xs={1} style={{ textAlign: "left" }}>
            <i
              className="material-icons-outlined"
              style={{
                color: isUploaded
                  ? palette.secondary.main
                  : palette.text.secondary,
                fontSize: 24,
              }}
            >
              {fileType === "image" ? "image" : "insert_drive_file"}
            </i>
          </Grid>
          <Grid item xs={10}>
            <Box pl={2} pr={2}>
              <Typography
                variant="caption"
                align="left"
                style={{
                  color: isUploaded ? "textPrimary" : "textSecondary",
                  width: "100%",
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {fileName}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1} style={{ textAlign: "right", height: 28 }}>
            {isUploaded ? (
              <i
                className="material-icons"
                style={{
                  color:
                    document.status === documentStatus.INCIDENCE
                      ? palette.warning.main
                      : palette.success.main,
                  fontSize: 24,
                }}
              >
                {document.status === documentStatus.INCIDENCE
                  ? "error"
                  : "check_circle"}
              </i>
            ) : isUploading ? (
              <CircularProgress
                className={"transition-all"}
                size={24}
                thickness={3}
                color="secondary"
              />
            ) : (
              <IconButton
                color="inherit"
                size="small"
                onClick={(e) => removeFile(e, file)}
              >
                <i
                  className="material-icons-outlined"
                  style={{
                    color: palette.text.secondary,
                    fontSize: 24,
                  }}
                >
                  delete
                </i>
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
